<template>
    <div id="settings-workstation-types-page">
        <settings-workstation-types></settings-workstation-types>
    </div>
</template>
<script>
import SettingsWorkstationTypes from './../components/workstations/SettingsWorkstationTypes';
export default {
    components: {
        'settings-workstation-types': SettingsWorkstationTypes,
    },
};
</script>
